import React, { useState } from "react";

import MyData from "../common/MyData";
import UserDNAForm from "./UserDNAForm";

const options = ["Mis datos", "Formulario ADN"];

function UserProfile() {
  const [selectedOption, setSelectedOption] = useState<number>(0);

  return (
    <div className="profile-dashboard">
      <div className="profile-navigation">
        <div className="options">
          {options.map((opt, index) => {
            return (
              <span
                onClick={() => setSelectedOption(index)}
                className={selectedOption === index ? "selected" : ""}
                key={index}
              >
                {opt}
              </span>
            );
          })}
        </div>
      </div>
      {selectedOption === 0 ? <MyData /> : <UserDNAForm />}
    </div>
  );
}

export default UserProfile;
